import * as React from 'react';
const CustomDnbDoor = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.21 36.46" {...props}>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M14.37 3.58h11.57a.79.79 0 0 1 .77.77V32.1a.76.76 0 0 1-.23.55.77.77 0 0 1-.54.22H14.37"
          className="custom_dnb_door_svg__cls-1"
        />
        <path
          d="M.5 32.45a.78.78 0 0 0 .17.48.76.76 0 0 0 .43.27l12.34 2.74a1 1 0 0 0 .34 0 .9.9 0 0 0 .31-.15.8.8 0 0 0 .21-.27.75.75 0 0 0 .07-.33V1.27a.75.75 0 0 0-.07-.33.7.7 0 0 0-.21-.27.9.9 0 0 0-.31-.15.65.65 0 0 0-.34 0L1.1 3.26a.76.76 0 0 0-.43.27A.78.78 0 0 0 .5 4z"
          className="custom_dnb_door_svg__cls-1"
        />
        <path d="M9 20.54a2.31 2.31 0 1 0-2.31-2.31A2.3 2.3 0 0 0 9 20.54" className="custom_dnb_door_svg__cls-1" />
      </g>
    </g>
  </svg>
);
export default CustomDnbDoor;
